import type { ApprovedCodeView, DesignationView, GradeLinkView } from "../types";

export interface NomenclatureNumbers {
  gradeCount: number;
  rsCodeCount: number;
  approvedCodeCount: number;
  gradesWithTdsCount: number;
}

export function nomenclatureNumbers(
  designations: DesignationView[],
  gradeLinks: GradeLinkView[],
  approvedCodes: ApprovedCodeView[],
): NomenclatureNumbers {
  const gradeIds = new Set(gradeLinks.map((gradeLink) => gradeLink.gradeId));
  const gradeIdsWithTds = new Set(
    gradeLinks.filter((gradeLink) => (gradeLink.tdsFileCount ?? 0) > 0).map((gradeLink) => gradeLink.gradeId),
  );
  return {
    gradeCount: gradeIds.size,
    rsCodeCount: designations.length,
    approvedCodeCount: approvedCodes.length,
    gradesWithTdsCount: gradeIdsWithTds.size,
  };
}
